<div class="component-content">
  <div class="grid-fixed-container">
    <form [formGroup]="searchForm">
      <div class="search-container">
        <div id="search">
          <button [hidden]="true"></button>
          <mat-icon class="icon-16" matPrefix svgIcon="search"></mat-icon>
          <input placeholder="Search..." #searchInput formControlName="searchTerm" />
        </div>
        <button mat-button color="primary" [disabled]="
            (this.searchForm.pristine && !this.periodChangedFlag) ||
            this.isSearchFormEmpty()
          " title="Reset" (click)="resetSearch()">
          <mat-icon class="icon-display-size reset-fliters-icon">restart_alt</mat-icon>
        </button>
      </div>
      <div id="advanced-search">
        <button mat-button (click)="toggleAdvancedSearch()">
          <mat-icon svgIcon="expand-more"></mat-icon>Advanced
        </button>
        <mat-expansion-panel class="advanced-search-panel mat-elevation-z0" [expanded]="advancedSearchOpened">
          <div class="form-field full-width">
            <mat-form-field class="lc-form-field" appearance="outline">
              <label>Customers</label>
              <mat-select formControlName="customers" #customersSelect multiple
                (openedChange)="customersSelectToggled()">
                <mat-select-trigger>
                  {{
                  customersSelect.value
                  ? getCustomerName(customersSelect.value[0])
                  : ""
                  }}
                  <span *ngIf="customersSelect.value?.length > 1">
                    (+{{ customersSelect.value.length - 1 }}
                    {{
                    customersSelect.value?.length === 2 ? "other" : "others"
                    }})
                  </span>
                </mat-select-trigger>
                <mat-form-field class="form-field inner-mat-input lc-form-field" appearance="outline">
                  <input matInput #customersSearch placeholder="Search..."
                    (input)="filterCustomers(customersSearch.value)" />
                </mat-form-field>
                <div class="overflow-list">
                  <div *ngFor="let customer of customersDictionary | sortBy:'name'">
                    <div [hidden]="!isCustomerInFilter(customer)">
                      <mat-option [value]="customer.id">{{
                        customer.name
                        }}</mat-option>
                    </div>
                  </div>
                </div>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-field">
            <mat-form-field class="lc-form-field" appearance="outline">
              <label>Flow</label>
              <mat-select formControlName="flows" multiple>
                <mat-option *ngFor="let flow of flows | sortBy" [value]="flow">
                  {{ flow }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-field">
            <mat-form-field class="lc-form-field" appearance="outline">
              <label>Status</label>
              <mat-select formControlName="statuses" multiple>
                <mat-option *ngFor="let status of taskStatuses | sortBy" [value]="status">
                  {{ status }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-field full-width">
            <mat-form-field class="lc-form-field" appearance="outline">
              <label>Laboratory</label>
              <mat-select formControlName="customerLaboratory" #laboratoriesSelect multiple
                (openedChange)="laboratoriesSelectToggled()">
                <mat-select-trigger>
                  {{
                  laboratoriesSelect.value
                  ? getLaboratoryName(laboratoriesSelect.value[0])
                  : ""
                  }}
                  <span *ngIf="laboratoriesSelect.value?.length > 1">
                    (+{{ laboratoriesSelect.value.length - 1 }}
                    {{
                    laboratoriesSelect.value?.length === 2
                    ? "other"
                    : "others"
                    }})
                  </span>
                </mat-select-trigger>
                <mat-form-field class="form-field inner-mat-input lc-form-field" appearance="outline">
                  <input matInput #laboratorySearch placeholder="Search..."
                    (input)="filterLaboratories(laboratorySearch.value)" />
                </mat-form-field>
                <div class="overflow-list">
                  <div *ngFor="let laboratory of laboratories$ | async | sortBy:'name'">
                    <div [hidden]="!isLaboratoryInFilter(laboratory)">
                      <mat-option [value]="laboratory.id">{{
                        laboratory.name
                        }}</mat-option>
                    </div>
                  </div>
                </div>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <app-tasks-date-range-filter (dateChanged)="periodChanged()"></app-tasks-date-range-filter>
          </div>
          <div id="search-submit">
            <button class="lc-stroked-button lc-primary" mat-stroked-button (click)="applyFilters()">
              <mat-icon svgIcon="search-white"></mat-icon>Search
            </button>
          </div>
        </mat-expansion-panel>
      </div>
    </form>

    <div id="table-loading-buttons">
      <button mat-button (click)="refresh()">
        <mat-icon svgIcon="refresh"></mat-icon>Refresh list
      </button>

      <mat-checkbox class="example-margin" color="primary" [checked]="autoRefresh" (change)="autoRefreshChanged($event)">Auto refresh
      </mat-checkbox>
    </div>
  </div>

  <div class="grid-scrollable-container">
    <table class="lc-table" mat-table [dataSource]="dataSource" matSort matSortActive="createStamp" matSortDirection="desc">
      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>
          <app-status-filter [showIcons]="false" [items]="statuses" (selectionChanged)="applyStatusesFilter($event)">
          </app-status-filter>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-icon [svgIcon]="
              getTaskStatusIcon(element.requestedProcess, element.state)
            " [title]="
              getTaskStatusIconTitle(element.requestedProcess, element.state)
            ">
          </mat-icon>
        </td>
      </ng-container>
      <!-- Flow Column -->
      <ng-container matColumnDef="flow">
        <th mat-header-cell *matHeaderCellDef>
          <app-input-output-filter (selectionChanged)="applyInputOutputFilter($event)"></app-input-output-filter>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-icon svgIcon="arrow-right" class="icon-16" *ngIf="element.processFlow === processFlow.order"
            title="Order"></mat-icon>
          <mat-icon svgIcon="arrow-right-hollow" class="icon-16" *ngIf="element.processFlow === processFlow.action"
            title="Action"></mat-icon>
          <mat-icon svgIcon="arrow-left" class="icon-16" *ngIf="element.processFlow === processFlow.result"
            title="Result"></mat-icon>
          <mat-icon svgIcon="arrow-left-hollow" class="icon-16" *ngIf="element.processFlow === processFlow.invoice"
            title="Invoice"></mat-icon>
        </td>
      </ng-container>
      <!-- Customer Name Column -->
      <ng-container matColumnDef="customerName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Customer
          <div (click)="$event.stopPropagation()">
            <app-search-select-multiple [activateSearch]="true" [items]="customerNames"
              (selectionChanged)="applyCustomersFilter($event)"></app-search-select-multiple>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.customerName }}</td>
      </ng-container>

      <!-- Create date Column -->
      <ng-container matColumnDef="createStamp">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Date
          <div (click)="$event.stopPropagation()">
            <app-datetime-range-filter (selectionChanged)="applyDateTimeFilter($event)"></app-datetime-range-filter>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.createStamp | date: "short" }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{ selectedRow: selectedTaskId === row.id }"
        (click)="selectRow(row.id)"></tr>

      <!-- Row shown when there is no matching data. -->
      <tr class="mat-row" *matNoDataRow>
        <ng-container [ngSwitch]="displayedTextIfEmpty()">
          <td class="mat-cell" colspan="3" *ngSwitchCase="'normalSearch'">
            No data matching the search value "{{ lastSentSearchTerm }}"
          </td>
          <td class="mat-cell" colspan="3" *ngSwitchCase="'extendedSearch'">
            No data is matching the search
          </td>
          <td class="mat-cell" colspan="3" *ngSwitchDefault>
            No data to display
          </td>
        </ng-container>
      </tr>
    </table>
  </div>
  <div class="grid-paginator-container">
    <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
  </div>
</div>